/* JAEL Café — comportamiento del encabezado propio.

   Tres piezas independientes que comparten reglas:
     · Cajón de navegación en móvil y tableta.
     · Acordeones de primer nivel dentro del cajón (uno abierto a la vez).
     · Paneles de escritorio a ancho completo (Tienda, El ritual, JAEL).

   Sin dependencias, sin librerías y sin tocar ningún módulo de Trade. El
   marcado sale de Liquid ya utilizable: los paneles llevan `hidden` desde el
   servidor —salvo el grupo marcado para abrirse al entrar— y, si el script no
   llega a ejecutarse, `<noscript>` los deja visibles en línea para que la
   navegación siga siendo alcanzable.

   «Familia» agrupa a los que se cierran entre sí: abrir un grupo del cajón no
   cierra el cajón, y abrir un panel de escritorio no toca a los demás. */
(function () {
  'use strict';

  var escritorio = window.matchMedia('(min-width: 990px)');
  var punteroFino = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Cada disparador registra aquí cómo cerrarse, de modo que abrir uno cierre
     a los de su familia sin que ninguno conozca al resto. */
  var abiertos = [];

  function cerrarFamilia(familia, excepto) {
    abiertos.slice().forEach(function (entrada) {
      if (entrada !== excepto && entrada.familia === familia) entrada.cerrar();
    });
  }

  function cerrarTodos() {
    abiertos.slice().forEach(function (entrada) {
      entrada.cerrar();
    });
  }

  function escucharMedia(consulta, fn) {
    if (consulta.addEventListener) {
      consulta.addEventListener('change', fn);
    } else if (consulta.addListener) {
      consulta.addListener(fn);
    }
  }

  function conectar(boton, opciones) {
    var panel = document.getElementById(boton.getAttribute('aria-controls'));
    if (!panel) return;

    var config = opciones || {};
    var temporizador = null;

    var entrada = {
      familia: boton.getAttribute('data-jael-familia') || 'suelto',
      cerrar: function () {
        fijar(false);
      },
    };

    function abierto() {
      return boton.getAttribute('aria-expanded') === 'true';
    }

    function fijar(estado, devolverFoco) {
      boton.setAttribute('aria-expanded', estado ? 'true' : 'false');
      panel.hidden = !estado;

      var indice = abiertos.indexOf(entrada);
      if (estado && indice === -1) abiertos.push(entrada);
      if (!estado && indice !== -1) abiertos.splice(indice, 1);

      if (!estado && devolverFoco) boton.focus();
    }

    function cancelarCierre() {
      if (temporizador) {
        clearTimeout(temporizador);
        temporizador = null;
      }
    }

    boton.addEventListener('click', function () {
      var siguiente = !abierto();
      cerrarFamilia(entrada.familia, entrada);
      cancelarCierre();
      fijar(siguiente);
    });

    // Elegir un destino cierra el panel: el ancla queda a la vista.
    panel.addEventListener('click', function (evento) {
      if (!evento.target.closest('a')) return;
      fijar(false);
      // Desde el cajón, además, se cierra el cajón entero.
      if (config.cerrarCajonAlElegir) cerrarFamilia('cajon', null);
    });

    // Escape cierra y devuelve el foco al disparador.
    boton.addEventListener('keydown', alPulsarEscape);
    panel.addEventListener('keydown', alPulsarEscape);
    function alPulsarEscape(evento) {
      if (evento.key !== 'Escape' || !abierto()) return;
      evento.stopPropagation();
      fijar(false, true);
    }

    // Salir del grupo con el tabulador también lo cierra.
    if (config.cerrarAlSalirDelFoco) {
      var grupo = config.cerrarAlSalirDelFoco;
      grupo.addEventListener('focusout', function (evento) {
        if (!abierto()) return;
        if (evento.relatedTarget && grupo.contains(evento.relatedTarget)) return;
        fijar(false);
      });
    }

    // En escritorio con puntero fino el grupo también abre al pasar por encima.
    if (config.abrirAlPasar) {
      var zona = config.abrirAlPasar;
      zona.addEventListener('pointerenter', function (evento) {
        if (evento.pointerType !== 'mouse') return;
        if (!escritorio.matches || !punteroFino.matches) return;
        cancelarCierre();
        cerrarFamilia(entrada.familia, entrada);
        fijar(true);
      });
      zona.addEventListener('pointerleave', function (evento) {
        if (evento.pointerType !== 'mouse') return;
        if (!escritorio.matches || !punteroFino.matches) return;
        cancelarCierre();
        temporizador = setTimeout(function () {
          fijar(false);
        }, 180);
      });
    }

    escucharMedia(escritorio, function () {
      // Al cruzar el punto de quiebre la otra navegación toma el relevo.
      fijar(false);
    });

    // Estado inicial: se respeta el que llega del servidor (Tienda abierta).
    fijar(abierto());
  }

  function arrancar() {
    var cabecera = document.querySelector('[data-jael-header]');
    if (!cabecera) return;

    var menu = cabecera.querySelector('[data-jael-menu]');
    if (menu) conectar(menu, { cerrarAlSalirDelFoco: cabecera });

    cabecera.querySelectorAll('[data-jael-grupo]').forEach(function (boton) {
      if (boton.getAttribute('data-jael-familia') === 'movil') {
        conectar(boton, { cerrarCajonAlElegir: true });
        return;
      }
      var contenedor = boton.closest('.jael-header__item');
      conectar(boton, {
        abrirAlPasar: contenedor,
        cerrarAlSalirDelFoco: contenedor,
      });
    });

    // Un clic fuera del encabezado cierra cualquier panel abierto.
    document.addEventListener('click', function (evento) {
      if (cabecera.contains(evento.target)) return;
      cerrarTodos();
    });

    // En scroll la barra se recoge de 84 a 64 px. Sin sombra ni salto.
    var recogida = false;
    function alDesplazar() {
      var debe = window.scrollY > 24;
      if (debe === recogida) return;
      recogida = debe;
      cabecera.classList.toggle('jael-header--compacta', debe);
    }
    window.addEventListener('scroll', alDesplazar, { passive: true });
    alDesplazar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
